import {
  GET_ACCCATEGORY,
  GET_ACCCATEGORY_SUCCESS,
  GET_ACCCATEGORY_FAIL,
  DELETE_ACCCATEGORY,
  DELETE_ACCCATEGORY_SUCCESS,
  DELETE_ACCCATEGORY_FAIL,
  UPDATE_ACCCATEGORY,
  UPDATE_ACCCATEGORY_SUCCESS,
  UPDATE_ACCCATEGORY_FAIL,
  ADD_NEW_ACCCATEGORY,
  ADD_ACCCATEGORY_SUCCESS,
  ADD_ACCCATEGORY_FAIL,
  ACCCATEGORY_LOADING,
  ACCCATEGORY_RESET,
} from "./actionType";

export const resetAccCategoryState = (actionType) => ({
  type: ACCCATEGORY_RESET,
  payload: { actionType },
});

export const getAccCategorySuccess = (actionType, data) => ({
  type: GET_ACCCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getAccCategoryFail = (actionType, error) => ({
  type: GET_ACCCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getAccCategory = data => ({
  type: GET_ACCCATEGORY,
  payload: data,
});

export const getAccCategoryLoading = () => ({
  type: ACCCATEGORY_LOADING
});

export const deleteAccCategory = data => ({
  type: DELETE_ACCCATEGORY,
  payload: data,
});

export const deleteAccCategorySuccess = data => ({
  type: DELETE_ACCCATEGORY_SUCCESS,
  payload: data,
});

export const deleteAccCategoryFail = error => ({
  type: DELETE_ACCCATEGORY_FAIL,
  payload: error,
});

export const updateAccCategory = data => ({
  type: UPDATE_ACCCATEGORY,
  payload: data,
});

export const updateAccCategoryFail = error => ({
  type: UPDATE_ACCCATEGORY_FAIL,
  payload: error,
});

export const updateAccCategorySuccess = data => ({
  type: UPDATE_ACCCATEGORY_SUCCESS,
  payload: data,
});

export const addNewAccCategory = data => ({
  type: ADD_NEW_ACCCATEGORY,
  payload: data,
});

export const addAccCategorySuccess = data => ({
  type: ADD_ACCCATEGORY_SUCCESS,
  payload: data,
});

export const addAccCategoryFail = error => ({
  type: ADD_ACCCATEGORY_FAIL,
  payload: error,
});